import React from 'react';
import { Lock } from 'lucide-react';
import CustomSelect from '../../shared/CustomSelect';

const PrivacySettings = ({ privacy, onChange }) => {
  const visibilityOptions = [
    { value: 'public', label: 'Public' },
    { value: 'private', label: 'Private' },
    { value: 'friends', label: 'Friends Only' }
  ];

  return (
    <div className="bg-white rounded-lg border border-black p-3 sm:p-4 md:p-6">
      <div className="flex items-center space-x-2 mb-3 sm:mb-4">
        <Lock className="w-4 h-4 sm:w-5 sm:h-5 text-black flex-shrink-0" />
        <h2 className="text-lg sm:text-xl font-bold text-black">Privacy</h2>
      </div>
      <div className="space-y-3 sm:space-y-4">
        <CustomSelect
          label="Profile Visibility"
          value={privacy.profileVisibility}
          onChange={(value) => onChange('profileVisibility', value)}
          options={visibilityOptions}
          placeholder="Select visibility"
          size="md"
        />
        <div className="flex items-center justify-between py-2">
          <label className="text-xs sm:text-sm font-medium text-gray-700 flex-1 pr-4">
            Show Email Address
          </label>
          <button
            onClick={() => onChange('showEmail', !privacy.showEmail)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors flex-shrink-0 active:scale-95 ${
              privacy.showEmail ? 'bg-black' : 'bg-gray-300'
            }`}
            aria-label="Toggle show email"
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                privacy.showEmail ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
        <div className="flex items-center justify-between py-2">
          <label className="text-xs sm:text-sm font-medium text-gray-700 flex-1 pr-4">
            Show Phone Number
          </label>
          <button
            onClick={() => onChange('showPhone', !privacy.showPhone)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors flex-shrink-0 active:scale-95 ${
              privacy.showPhone ? 'bg-black' : 'bg-gray-300'
            }`}
            aria-label="Toggle show phone"
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                privacy.showPhone ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettings;

